import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import {
  MbProductTabSpecificationsAdapter
} from '../connectors/specifications/mb-product-tab-specifications.adapter'
import { MB_PRODUCT_TAB_SPECIFICATION_NORMALIZER } from '../connectors/specifications/mb-converters'

@Injectable({
  providedIn: 'root'
})
export class MbOccProductSpecificationsAdapter implements MbProductTabSpecificationsAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (productCode: string, maxCount?: number) {
    return this.http.get(this.getEndpoint(productCode, maxCount)).pipe(
      this.converter.pipeable(MB_PRODUCT_TAB_SPECIFICATION_NORMALIZER)
    )
  }

  protected getEndpoint (code: string, maxCount?: number) {
    return this.occEndpoints.buildUrl(
      'productTabSpecifications',
      {
        urlParams: { productCode: code },
        queryParams: { maxCount },
      }
    )
  }
}

